// Error
export const ERROR_CLEAR = 'ERROR_CLEAR';

// Alerts
export const ALERT_ADD = 'ALERT_ADD';

// Form
export const FORM_ISDIRTY = 'FORM_ISDIRTY';

// Reports
export const REPORT_START = 'REPORT_START';
export const REPORT_FAIL = 'REPORT_FAIL';
export const REPORT_SUCCESS = 'REPORT_SUCCESS';

// Admin Groups
export const ADMINGROUP_START = 'ADMINGROUP_START';
export const ADMINGROUP_FAIL = 'ADMINGROUP_FAIL';
export const ADMINGROUP_SUCCESS = 'ADMINGROUP_SUCCESS';
export const ADMINGROUP_RESET = 'ADMINGROUP_RESET';

// Communication Groups
export const COMMUNICATION_GROUP_START = 'COMMUNICATION_START';
export const COMMUNICATION_GROUP_FAIL = 'COMMUNICATION_GROUP_FAIL';
export const COMMUNICATION_GROUP_SUCCESS = 'COMMUNICATION_GROUP_SUCCESS';
export const COMMUNICATION_GROUP_RESET = 'COMMUNICATION_GROUP_RESET';

// Authentication
export const AUTHENTICATION_START = 'AUTHENTICATION_START';
export const AUTHENTICATION_FAIL = 'AUTHENTICATION_FAIL';
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_LOGOUT = 'AUTHENTICATION_LOGOUT';
export const AUTHENTICATION_CLEAR = 'AUTHENTICATION_CLEAR';

// Breadcrumb
export const BREADCRUMB_ADD_ROUTE = 'BREADCRUMB_ADD_ROUTE';
export const BREADCRUMB_REMOVE_ROUTE = 'BREADCRUMB_REMOVE_ROUTE';
export const BREADCRUMB_REMOVE_ALL_ROUTES = 'BREADCRUMB_REMOVE_ALL_ROUTES';

// Franchise News
export const FRANCHISENEWS_START = 'FRANCHISENEWS_START';
export const FRANCHISENEWS_FAIL = 'FRANCHISENEWS_FAIL';
export const FRANCHISENEWS_SUCCESS = 'FRANCHISENEWS_SUCCESS';

// FranchiseReports
export const FRANCHISE_REPORT_START = 'FRANCHISE_REPORT_START';
export const FRANCHISE_REPORT_FAIL = 'FRANCHISE_REPORT_FAIL';
export const FRANCHISE_REPORT_SUCCESS = 'FRANCHISE_REPORT_SUCCESS';

// Global File
export const GLOBALFILE_START = 'GLOBALFILE_START';
export const GLOBALFILE_FAIL = 'GLOBALFILE_FAIL';
export const GLOBALFILE_SUCCESS = 'GLOBALFILE_SUCCESS';

// Lookup Type
export const LOOKUPTYPE_START = 'LOOKUPTYPE_START';
export const LOOKUPTYPE_FAIL = 'LOOKUPTYPE_FAIL';
export const LOOKUPTYPE_SUCCESS = 'LOOKUPTYPE_SUCCESS';

// Lookup Category
export const LOOKUPCATEGORY_START = 'LOOKUPCATEGORY_START';
export const LOOKUPCATEGORY_FAIL = 'LOOKUPCATEGORY_FAIL';
export const LOOKUPCATEGORY_SUCCESS = 'LOOKUPCATEGORY_SUCCESS';

// File
export const FILE_START = 'FILE_START';
export const FILE_FAIL = 'FILE_FAIL';
export const FILE_SUCCESS = 'FILE_SUCCESS';

// Fee
export const FEE_START = 'FEE_START';
export const FEE_FAIL = 'FEE_FAIL';
export const FEE_SUCCESS = 'FEE_SUCCESS';

// Note
export const NOTE_START = 'NOTE_START';
export const NOTE_FAIL = 'NOTE_FAIL';
export const NOTE_SUCCESS = 'NOTE_SUCCESS';

// User
export const USER_START = 'USER_START';
export const USER_FAIL = 'USER_FAIL';
export const USER_SUCCESS = 'USER_SUCCESS';

// Email
export const EMAIL_START = 'EMAIL_START';
export const EMAIL_FAIL = 'EMAIL_FAIL';
export const EMAIL_SUCCESS = 'EMAIL_SUCCESS';

// Phone Number
export const PHONENUMBER_START = 'PHONENUMBER_START';
export const PHONENUMBER_FAIL = 'PHONENUMBER_FAIL';
export const PHONENUMBER_SUCCESS = 'PHONENUMBER_SUCCESS';

// Utility
export const UTILITY_START = 'UTILITY_START';
export const UTILITY_FAIL = 'UTILITY_FAIL';
export const UTILITY_SUCCESS = 'UTILITY_SUCCESS';

// Territory
export const TERRITORY_START = 'TERRITORY_START';
export const TERRITORY_FAIL = 'TERRITORY_FAIL';
export const TERRITORY_SUCCESS = 'TERRITORY_SUCCESS';

// Mls Provider
export const MLSPROVIDER_START = 'MLSPROVIDER_START';
export const MLSPROVIDER_FAIL = 'MLSPROVIDER_FAIL';
export const MLSPROVIDER_SUCCESS = 'MLSPROVIDER_SUCCESS';

// Mls Provider Franchise (MlsProvider List of FranchiseS)
export const MLSPROVIDERFRANCHISE_START = 'MLSPROVIDERFRANCHISE_START';
export const MLSPROVIDERFRANCHISE_FAIL = 'MLSPROVIDERFRANCHISE_FAIL';
export const MLSPROVIDERFRANCHISE_SUCCESS = 'MLSPROVIDERFRANCHISE_SUCCESS';

// Branch Office Mls Provider
export const BRANCHOFFICEMLSPROVIDER_START = 'BRANCHOFFICEMLSPROVIDER_START';
export const BRANCHOFFICEMLSPROVIDER_FAIL = 'BRANCHOFFICEMLSPROVIDER_FAIL';
export const BRANCHOFFICEMLSPROVIDER_SUCCESS = 'BRANCHOFFICEMLSPROVIDER_SUCCESS';

// Franchise Mls Provider (Do not get above this one confused, they do two different things)
export const FRANCHISEMLSPROVIDER_START = 'FRANCHISEMLSPROVIDER_START';
export const FRANCHISEMLSPROVIDER_FAIL = 'FRANCHISEMLSPROVIDER_FAIL';
export const FRANCHISEMLSPROVIDER_SUCCESS = 'FRANCHISEMLSPROVIDER_SUCCESS';

// Real Estate Board
export const REALESTATEBOARD_START = 'REALESTATEBOARD_START';
export const REALESTATEBOARD_FAIL = 'REALESTATEBOARD_FAIL';
export const REALESTATEBOARD_SUCCESS = 'REALESTATEBOARD_SUCCESS';

// Department of Real Estate
export const DEPARTMENTOFREALESTATE_START = 'DEPARTMENTOFREALESTATE_START';
export const DEPARTMENTOFREALESTATE_FAIL = 'DEPARTMENTOFREALESTATE_FAIL';
export const DEPARTMENTOFREALESTATE_SUCCESS = 'DEPARTMENTOFREALESTATE_SUCCESS';

// Franchise Accounting
export const FRANCHISEACCOUNTING_START = 'FRANCHISEACCOUNTING_START';
export const FRANCHISEACCOUNTING_FAIL = 'FRANCHISEACCOUNTING_FAIL';
export const FRANCHISEACCOUNTING_SUCCESS = 'FRANCHISEACCOUNTING_SUCCESS';
export const FRANCHISEACCOUNTING_RESET = 'FRANCHISEACCOUNTING_RESET';

// Franchise Agent Product
export const FRANCHISEAGENTPRODUCT_START = 'FRANCHISEAGENTPRODUCT_START';
export const FRANCHISEAGENTPRODUCT_FAIL = 'FRANCHISEAGENTPRODUCT_FAIL';
export const FRANCHISEAGENTPRODUCT_SUCCESS = 'FRANCHISEAGENTPRODUCT_SUCCESS';
export const FRANCHISEAGENTPRODUCT_RESET = 'FRANCHISEAGENTPRODUCT_RESET';

// Franchise Agent Product Fee
export const FRANCHISEAGENTPRODUCTFEE_START = 'FRANCHISEAGENTPRODUCTFEE_START';
export const FRANCHISEAGENTPRODUCTFEE_FAIL = 'FRANCHISEAGENTPRODUCTFEE_FAIL';
export const FRANCHISEAGENTPRODUCTFEE_SUCCESS = 'FRANCHISEAGENTPRODUCTFEE_SUCCESS';
export const FRANCHISEAGENTPRODUCTFEE_LISTRESET = 'FRANCHISEAGENTPRODUCTFEE_LISTRESET';

// Franchise Product
export const FRANCHISEPRODUCT_START = 'FRANCHISEPRODUCT_START';
export const FRANCHISEPRODUCT_FAIL = 'FRANCHISEPRODUCT_FAIL';
export const FRANCHISEPRODUCT_SUCCESS = 'FRANCHISEPRODUCT_SUCCESS';
export const FRANCHISEPRODUCT_RESET = 'FRANCHISEPRODUCT_RESET';

// Franchise Product Fee
export const FRANCHISEPRODUCTFEE_START = 'FRANCHISEPRODUCTFEE_START';
export const FRANCHISEPRODUCTFEE_FAIL = 'FRANCHISEPRODUCTFEE_FAIL';
export const FRANCHISEPRODUCTFEE_SUCCESS = 'FRANCHISEPRODUCTFEE_SUCCESS';
export const FRANCHISEPRODUCTFEE_LISTRESET = 'FRANCHISEPRODUCTFEE_LISTRESET';

// Franchise Product Template
export const FRANCHISEPRODUCTTEMPLATE_START = 'FRANCHISEPRODUCTTEMPLATE_START';
export const FRANCHISEPRODUCTTEMPLATE_FAIL = 'FRANCHISEPRODUCTTEMPLATE_FAIL';
export const FRANCHISEPRODUCTTEMPLATE_SUCCESS = 'FRANCHISEPRODUCTTEMPLATE_SUCCESS';
export const FRANCHISEPRODUCTTEMPLATE_RESET = 'FRANCHISEPRODUCTTEMPLATE_RESET';

// Franchise Product Fee Template
export const FRANCHISEPRODUCTTEMPLATEFEE_START = 'FRANCHISEPRODUCTTEMPLATEFEE_START';
export const FRANCHISEPRODUCTTEMPLATEFEE_FAIL = 'FRANCHISEPRODUCTTEMPLATEFEE_FAIL';
export const FRANCHISEPRODUCTTEMPLATEFEE_SUCCESS = 'FRANCHISEPRODUCTTEMPLATEFEE_SUCCESS';
export const FRANCHISEPRODUCTTEMPLATEFEE_LISTRESET = 'FRANCHISEPRODUCTTEMPLATEFEE_LISTRESET';

// Franchise Income Accounts
export const FRANCHISEINCOMEACCOUNT_START = 'FRANCHISEINCOMEACCOUNT_START';
export const FRANCHISEINCOMEACCOUNT_FAIL = 'FRANCHISEINCOMEACCOUNT_FAIL';
export const FRANCHISEINCOMEACCOUNT_SUCCESS = 'FRANCHISEINCOMEACCOUNT_SUCCESS';
export const FRANCHISEINCOMEACCOUNT_LISTRESET = 'FRANCHISEINCOMEACCOUNT_LISTRESET';

// Franchise User
export const FRANCHISEUSER_START = 'FRANCHISEUSER_START';
export const FRANCHISEUSER_FAIL = 'FRANCHISEUSER_FAIL';
export const FRANCHISEUSER_SUCCESS = 'FRANCHISEUSER_SUCCESS';
export const FRANCHISEUSER_LISTRESET = 'FRANCHISEUSER_LISTRESET';

// Net Suite Items
export const NETSUITEITEM_START = 'NETSUITEITEM_START';
export const NETSUITEITEM_FAIL = 'NETSUITEITEM_FAIL';
export const NETSUITEITEM_SUCCESS = 'NETSUITEITEM_SUCCESS';
export const NETSUITEITEM_LISTRESET = 'NETSUITEITEM_LISTRESET';

// Product
export const PRODUCT_START = 'PRODUCT_START';
export const PRODUCT_FAIL = 'PRODUCT_FAIL';
export const PRODUCT_SUCCESS = 'PRODUCT_SUCCESS';
export const PRODUCT_RESET = 'PRODUCT_RESET';

// MasterBlaster
export const MASTERBLASTER_START = 'MASTERBLASTER_START';
export const MASTERBLASTER_FAIL = 'MASTERBLASTER_FAIL';
export const MASTERBLASTER_SUCCESS = 'MASTERBLASTER_SUCCESS';
export const MASTERBLASTER_RESET = 'MASTERBLASTER_RESET';

// Doing Business As
export const DOINGBUSINESSAS_START = 'DOINGBUSINESSAS_START';
export const DOINGBUSINESSAS_FAIL = 'DOINGBUSINESSAS_FAIL';
export const DOINGBUSINESSAS_SUCCESS = 'DOINGBUSINESSAS_SUCCESS';

// Commission Plan Template
export const COMMISSIONPLANTEMPLATE_START = 'COMMISSIONPLANTEMPLATE_START';
export const COMMISSIONPLANTEMPLATE_FAIL = 'COMMISSIONPLANTEMPLATE_FAIL';
export const COMMISSIONPLANTEMPLATE_SUCCESS = 'COMMISSIONPLANTEMPLATE_SUCCESS';

// Commission Plan Fee Template
export const COMMISSIONPLANFEETEMPLATE_START = 'COMMISSIONPLANFEETEMPLATE_START';
export const COMMISSIONPLANFEETEMPLATE_FAIL = 'COMMISSIONPLANFEETEMPLATE_FAIL';
export const COMMISSIONPLANFEETEMPLATE_SUCCESS = 'COMMISSIONPLANFEETEMPLATE_SUCCESS';
export const COMMISSIONPLANFEETEMPLATE_LISTRESET = 'COMMISSIONPLANFEETEMPLATE_LISTRESET';

// Commission Plan Type
export const COMMISSIONPLANTEMPLATETYPE_START = 'COMMISSIONPLANTEMPLATETYPE_START';
export const COMMISSIONPLANTEMPLATETYPE_FAIL = 'COMMISSIONPLANTEMPLATETYPE_FAIL';
export const COMMISSIONPLANTEMPLATETYPE_SUCCESS = 'COMMISSIONPLANTEMPLATETYPE_SUCCESS';

// Commission Plan Waiting Period
export const COMMISSIONPLANCHANGEWAITINGPERIOD_START = 'COMMISSIONPLANCHANGEWAITINGPERIOD_START';
export const COMMISSIONPLANCHANGEWAITINGPERIOD_FAIL = 'COMMISSIONPLANCHANGEWAITINGPERIOD_FAIL';
export const COMMISSIONPLANCHANGEWAITINGPERIOD_SUCCESS = 'COMMISSIONPLANCHANGEWAITINGPERIOD_SUCCESS';

// Commission Plan Document
export const COMMISSIONPLANDOCUMENT_START = 'COMMISSIONPLANDOCUMENT_START';
export const COMMISSIONPLANDOCUMENT_FAIL = 'COMMISSIONPLANDOCUMENT_FAIL';
export const COMMISSIONPLANDOCUMENT_SUCCESS = 'COMMISSIONPLANDOCUMENT_SUCCESS';

// Royalty Plan Template
export const ROYALTYPLANTEMPLATE_START = 'ROYALTYPLANTEMPLATE_START';
export const ROYALTYPLANTEMPLATE_FAIL = 'ROYALTYPLANTEMPLATE_FAIL';
export const ROYALTYPLANTEMPLATE_SUCCESS = 'ROYALTYPLANTEMPLATE_SUCCESS';

// Royalty Plan Fee Template
export const ROYALTYPLANFEETEMPLATE_START = 'ROYALTYPLANFEETEMPLATE_START';
export const ROYALTYPLANFEETEMPLATE_FAIL = 'ROYALTYPLANFEETEMPLATE_FAIL';
export const ROYALTYPLANFEETEMPLATE_SUCCESS = 'ROYALTYPLANFEETEMPLATE_SUCCESS';
export const ROYALTYPLANFEETEMPLATE_LISTRESET = 'ROYALTYPLANFEETEMPLATE_LISTRESET';

// Franchise Royalty Plan
export const FRANCHISEROYALTYPLAN_START = 'FRANCHISEROYALTYPLAN_START';
export const FRANCHISEROYALTYPLAN_FAIL = 'FRANCHISEROYALTYPLAN_FAIL';
export const FRANCHISEROYALTYPLAN_SUCCESS = 'FRANCHISEROYALTYPLAN_SUCCESS';

// Franchise Royalty Plan Fee
export const FRANCHISEROYALTYPLANFEE_START = 'FRANCHISEROYALTYPLANFEE_START';
export const FRANCHISEROYALTYPLANFEE_FAIL = 'FRANCHISEROYALTYPLANFEE_FAIL';
export const FRANCHISEROYALTYPLANFEE_SUCCESS = 'FRANCHISEROYALTYPLANFEE_SUCCESS';
export const FRANCHISEROYALTYPLANFEE_LISTRESET = 'FRANCHISEROYALTYPLANFEE_LISTRESET';

// Commission Plan
export const COMMISSIONPLAN_START = 'COMMISSIONPLAN_START';
export const COMMISSIONPLAN_FAIL = 'COMMISSIONPLAN_FAIL';
export const COMMISSIONPLAN_SUCCESS = 'COMMISSIONPLAN_SUCCESS';

// Marketing Area
export const MARKETINGAREA_START = 'MARKETINGAREA_START';
export const MARKETINGAREA_FAIL = 'MARKETINGAREA_FAIL';
export const MARKETINGAREA_SUCCESS = 'MARKETINGAREA_SUCCESS';

// Office
export const OFFICE_START = 'OFFICE_START';
export const OFFICE_FAIL = 'OFFICE_FAIL';
export const OFFICE_SUCCESS = 'OFFICE_SUCCESS';

// Franchise Admin
export const FRANCHISEADMIN_START = 'FRANCHISEADMIN_START';
export const FRANCHISEADMIN_FAIL = 'FRANCHISEADMIN_FAIL';
export const FRANCHISEADMIN_SUCCESS = 'FRANCHISEADMIN_SUCCESS';

// Franchise
export const FRANCHISE_START = 'FRANCHISE_START';
export const FRANCHISE_FAIL = 'FRANCHISE_FAIL';
export const FRANCHISE_SUCCESS = 'FRANCHISE_SUCCESS';

// Marketplace Vendor
export const MARKETPLACEVENDOR_START = 'MARKETPLACEVENDOR_START';
export const MARKETPLACEVENDOR_FAIL = 'MARKETPLACEVENDOR_FAIL';
export const MARKETPLACEVENDOR_SUCCESS = 'MARKETPLACEVENDOR_SUCCESS';

// Marketplace Vendor
export const MARKETPLACECATEGORY_START = 'MARKETPLACECATEGORY_START';
export const MARKETPLACECATEGORY_FAIL = 'MARKETPLACECATEGORY_FAIL';
export const MARKETPLACECATEGORY_SUCCESS = 'MARKETPLACECATEGORY_SUCCESS';

// Marketplace Deal
export const MARKETPLACEDEAL_START = 'MARKETPLACEDEAL_START';
export const MARKETPLACEDEAL_FAIL = 'MARKETPLACEDEAL_FAIL';
export const MARKETPLACEDEAL_SUCCESS = 'MARKETPLACEDEAL_SUCCESS';

// Marketplace Asset
export const MARKETPLACEASSET_START = 'MARKETPLACEASSET_START';
export const MARKETPLACEASSET_FAIL = 'MARKETPLACEASSET_FAIL';
export const MARKETPLACEASSET_SUCCESS = 'MARKETPLACEASSET_SUCCESS';

// Marketplace Franchise
export const MARKETPLACEFRANCHISE_START = 'MARKETPLACEFRANCHISE_START';
export const MARKETPLACEFRANCHISE_FAIL = 'MARKETPLACEFRANCHISE_FAIL';
export const MARKETPLACEFRANCHISE_SUCCESS = 'MARKETPLACEFRANCHISE_SUCCESS';

// Announcements
export const ANNOUNCEMENT_START = 'ANNOUNCEMENT_START';
export const ANNOUNCEMENT_FAIL = 'ANNOUNCEMENT_FAIL';
export const ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT_SUCCESS';
